import React from "react";
import { Typography, Box, useMediaQuery } from "@mui/material";
import backgroundImage from "../../assets/hero-img.jpg";

const Header = ({ heading, subHeading, subSubHeading, headerstyle }) => {
  const isMobile = useMediaQuery("(max-width: 720px)");
  const containerStyles = headerstyle
    ? headerstyle
    : {
        position: "relative",
        height: "500px",
        overflow: "hidden",
      };

  return (
    <Box
      sx={{
        ...containerStyles,
        position: "relative",
        overflow: "hidden",
      }}
    >
      <Box
        component="img"
        src={backgroundImage}
        alt="Background"
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
          filter: "blur(3px)",
          zIndex: 0,
        }}
      />
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          color: "white",
          gap: "1rem",
        }}
      >
        <Typography
          variant={isMobile ? "h3" : "h1"}
          sx={{
            fontFamily: "Poppins, sans-serif",
            fontWeight: "bold",
            textAlign: "center",
          }}
        >
          {heading}
        </Typography>
        <Typography
          variant={isMobile ? "h5" : "h4"}
          sx={{
            color: "#fff",
            fontFamily: "Poppins, sans-serif",
            fontWeight: "bold",
            textAlign: "center",
          }}
        >
          {subHeading}
        </Typography>
        <Typography
          variant={isMobile ? "body1" : "h5"}
          sx={{
            color: "#fff",
            fontFamily: "Poppins, sans-serif",
            fontWeight: "bold",
            textAlign: "center",
          }}
        >
          {subSubHeading}
        </Typography>
      </Box>
    </Box>
  );
};

export default Header;
